import { DropdownDataProps } from 'common/components/Select';

export const paymentList = [
  {
    label: 'Готівка',
    value: 1,
  },
  {
    label: 'Безготівковий розрахунок',
    value: 2,
  },
  {
    label: 'Банківська картка',
    value: 3,
  },
  {
    label: 'Інше',
    value: 4,
  },
] as DropdownDataProps[];
